import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Alert, Form, FormGroup, Label, Input, Button, Card, CardBody, Table } from 'reactstrap'

// Import API config object
import { tokenConfig } from '../utils/apiConfig'


//Additional Components to be loaded
import EventDetails from '../components/EventRegister/EventDetails'
import TermsAndConditions from '../components/EventRegister/TermsAndConditions'
import AttendeeDetails from '../components/EventRegister/AttendeeDetails'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const EventRegister = props => {

    const [name, setName] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [validId, setValidId] = useState('')
    const [dob, setDob] = useState('')
    const [email, setEmail] = useState('')
    const [events, setEvents] = useState([])
    const [guests, setGuests] = useState([])
    const [eventDetailsModal, setEventDetailsModal] = useState(false)
    const [termsAndConditionsModal, setTermsAndConditionsModal] = useState(false)
    const [futureContact, setFutureContact] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [indemnity, setIndemnity] = useState(false)

    const [selectedEventId, setSelectedEventId] = useState('')
    const [sessions, setSessions] = useState([])
    const [sessionId, setSessionId] = useState('')

    const [attendeeModal, setAttendeeModal] = useState(false)

    const userDetails = props.userDetails

    //Getting all Events using axios
    useEffect(() => {
        getEvents()
    }, [])

    useEffect(() => {
        setEmail(userDetails ? userDetails.user.email : '')
        setName(userDetails ? userDetails.user.name : '')
        setGuests(userDetails ? userDetails.user.guests : [])
        setDob(userDetails ? userDetails.user.dob : '')
        setValidId(userDetails ? userDetails.user.validId : '')
        setPhoneNumber(userDetails ? userDetails.user.phoneNumber : '')
    }, [userDetails])

    useEffect(() => {
        if (selectedEventId) {
            getEventSessions(selectedEventId)
        }
    }, [selectedEventId])

    const getEventSessions = async (eventId) => {
        setSessions([])
        const date = new Date()
        const dayBefore = date.setDate(date.getDate() - 1)
        const event = events.find(({ _id }) => _id === eventId)
        await axios.post('/api/event-sessions/getSessionsByEventId', { eventId, filters: { status: 'Open', date: { $gt: new Date(dayBefore).toISOString() }, registrations: { $lt: event.capacity } } }, tokenConfig())
            .then(res => setSessions(res.data))
            .catch(err => console.log(err))
    }

    const toggleAttendeeDetails = () => {
        setAttendeeModal(!attendeeModal)
    }

    const addGuest = (guest) => {
        setGuests([...guests, guest])
    }

    const deleteGuest = (index) => {
        const confirm = window.confirm("Remove Attendee?")
        if (confirm) {
            setGuests(guests.filter((e, i) => index !== i))
        }
    }

    const getEvents = async () => {
        await axios.post('/api/events/filter', { filter: { status: 'Open' } })
            .then(res => setEvents(res.data))
            .catch(err => console.log(err))
    }

    const toggleEventDetails = () => {
        setEventDetailsModal(!eventDetailsModal)
    }

    const toggleTermsAndConditions = () => {
        setTermsAndConditionsModal(!termsAndConditionsModal)
    }

    const acceptTermsAndConditions = () => {
        setIndemnity(true)
        setTermsAndConditionsModal(!termsAndConditionsModal)
    }

    const registerEvent = async e => {
        e.preventDefault()
        setErrorMessage('')
        setSuccessMessage('')
        if (!indemnity) {
            setErrorMessage('Required to Accept to Terms & Conditions')
        }
        const event = events.find(({ _id }) => _id === selectedEventId)

        const newRegistration = {
            event_id: selectedEventId,
            sessionId,
            futureContact,
            email,
            name,
            phoneNumber,
            validId,
            dob,
            guests,
            capacity: event.capacity
        }
        if (userDetails) {
            newRegistration.user_id = userDetails.user._id
        }
        await axios.post('/api/registrations', newRegistration)
            .then(async res => {
                setSuccessMessage('Registered, await confirmation email')
                setSelectedEventId('')
                setSessionId('')
                axios.patch('/api/event-sessions/registration', { ...newRegistration, registrationCount: guests.length + 1 })
                    .then(res => {
                        console.log(res.data)
                        window.scrollTo(0, 0)
                    })
                    .catch(err => {
                        setErrorMessage(err.response.data.message)
                        window.scrollTo(0, 0)
                    })
            })
            .catch(err => {
                setErrorMessage(err.response.data.message)
                window.scrollTo(0, 0)
            })

    }
    //Calling Backend using GraphQL
    return (
        <div>
            <EventDetails
                data={events}
                eventId={selectedEventId}
                modal={eventDetailsModal}
                toggleEventDetails={toggleEventDetails} />
            <TermsAndConditions
                modal={termsAndConditionsModal}
                toggle={toggleTermsAndConditions}
                acceptTermsAndConditions={acceptTermsAndConditions}
            />
            <AttendeeDetails
                modal={attendeeModal}
                toggle={toggleAttendeeDetails}
                addGuest={addGuest}
            />
            <center>
                <br />
                <h2><b>Friends of Bukit Kiara Events Registration</b></h2>
                <p>Reserve your slots now to take part in our exciting FoBK activities!</p>
            </center>
            <Card style={{ maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto' }}>
                <CardBody>
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    <Form onSubmit={e => registerEvent(e)}>
                        <FormGroup>
                            <Label>Full Name as per ID*</Label>
                            <Input
                                type="text"
                                placeholder="Your Name"
                                defaultValue={userDetails ? userDetails.user.name : name}
                                onChange={e => setName(e.target.value)}
                                required />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email*</Label>
                            <Input
                                type="email"
                                placeholder="Your Email"
                                defaultValue={userDetails ? userDetails.user.email : email}
                                onChange={e => setEmail(e.target.value)}
                                required />
                        </FormGroup>
                        <FormGroup>
                            <Label>Passport/IC*</Label>
                            <Input
                                type="text"
                                placeholder="Provide Valid ID"
                                defaultValue={userDetails ? userDetails.user.validId : validId}
                                onChange={e => setValidId(e.target.value)}
                                required
                            />
                            <p style={{ fontSize: '12px', color: 'grey' }}>Information is required for insurance purposes. All data will remain P&C and not be shared with any external parties.</p>
                        </FormGroup>
                        <FormGroup>
                            <Label>Date of Birth*</Label>
                            <Input
                                type="date"
                                defaultValue={userDetails ? userDetails.user.dob : dob}
                                onChange={e => setDob(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone Number*</Label>
                            <Input
                                type="text"
                                placeholder="Your Phone Number"
                                defaultValue={userDetails ? userDetails.user.phoneNumber : phoneNumber}
                                onChange={e => setPhoneNumber(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Additional Attendees</Label>
                            {guests?.length > 0 && <Table style={{ width: '100%' }} >
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>D.O.B</th>
                                        <th>ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {guests.map((guest, i) => <tr>
                                        <td style={{ width: "30%" }}>{guest.name}</td>
                                        <td style={{ width: "30%" }}>{new Date(guest.dob).toLocaleDateString()}</td>
                                        <td style={{ width: "30%" }}>{guest.validId}</td>
                                        <td style={{ width: "10%" }}>
                                            <span
                                                style={{ cursor: 'pointer', color: 'red' }}
                                                onClick={() => deleteGuest(i)}
                                            >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </span>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </Table>}
                            <div style={{ display: 'block' }}><Button onClick={toggleAttendeeDetails}>Add Attendee</Button></div>
                        </FormGroup>
                        <FormGroup>
                            <Label for="EventName">Event*</Label>
                            <Input
                                type="select"
                                value={selectedEventId}
                                onChange={e => {
                                    setSelectedEventId(e.target.value)
                                    setSessionId('')
                                }}
                                required >
                                <option value="">Select Event</option>
                                {events.map(({ _id, name }) => {
                                    return <option key={_id} value={_id}>{name}</option>
                                })}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="EventDate">Session*</Label>
                            <Input
                                type="select"
                                value={sessionId}
                                onChange={e => setSessionId(e.target.value)}
                                required>
                                <option value="">{!selectedEventId ? "Requires Event" : "Select a Date"}</option>
                                {sessions.map(({ _id, date, starttime, endtime }) =>
                                    <option key={_id} value={_id}>{date.substr(0, 10)}, {starttime}-{endtime}</option>
                                )}
                            </Input>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" defaultChecked={futureContact} onChange={e => setFutureContact(e.target.checked)} />{' '}
                                Keep me updated on future events
                            </Label>
                        </FormGroup>
                        <FormGroup check style={{ marginBottom: '5px' }}>
                            <Label check>
                                <Input type="checkbox" checked={indemnity} onChange={e => setIndemnity(e.target.checked)} required />{' '}
                                I accept the <a href='#' onClick={toggleTermsAndConditions}>Terms and Conditions</a>
                            </Label>
                        </FormGroup>
                        <Button color='primary' style={{ width: '49.5%', marginRight: '0.5%' }}>Submit</Button>
                        <Button color='info' style={{ width: '49.5%', marginLeft: '0.5%' }} onClick={toggleEventDetails}>
                            Event Details
                        </Button>
                        <br />
                        <a href="https://docs.google.com/document/d/1ThQNAsybXakeZpoqaG5OOs2zV0Z9i5njMpwCCbUtveg/edit?usp=sharing" target="_blank" style={{ fontSize: "10px", color: "black" }}>Privacy Policy</a>
                    </Form>
                </CardBody>
            </Card>

            <br />
            <center>
                <h2><b>Make your contribution.</b></h2>
                <p>Payments can be made either by cheque or direct bank-in*<br />
                    PERSATUAN SAHABAT RIMBA BUKIT KIARA<br />
                    CIMB Bank Account No 800-733-7109<br /><br />
                    If you are making an online payment please notify us at info@fobk.org</p>
            </center>
            <center>
                <div>
                    <a
                        target='blank'
                        href="https://f0bk.wordpress.com/"
                    >
                        <img style={{ width: "10%" }} src="https://f0bk.files.wordpress.com/2020/03/cropped-fobk-logo_black_no-background.png" />
                    </a>
                </div>
            </center>
        </div>
    )
}

export default EventRegister